var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "login-container",
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.login.apply(null, arguments)
        },
      },
    },
    [
      _c("img", {
        class: {
          "login-logo": _vm.VUEAPPWEBSETESIGN === "ps",
          "login-lt-logo": _vm.VUEAPPWEBSETESIGN === "lt",
        },
        attrs: { src: _vm.pcLogo, alt: "logo" },
      }),
      _c(
        "div",
        {
          class: {
            "login-logo-app": _vm.VUEAPPWEBSETESIGN === "ps",
            "login-logo-lt": _vm.VUEAPPWEBSETESIGN === "lt",
          },
        },
        [
          _c("img", {
            staticClass: "logo-app",
            attrs: { src: _vm.h5Logo, alt: "logo" },
          }),
        ]
      ),
      _c(
        "div",
        { staticClass: "form-box" },
        [
          _c("div", { staticClass: "form-title" }, [
            _vm._v(
              _vm._s(
                _vm.isCheckedEmail
                  ? _vm.$t("auth.setPassword")
                  : _vm.$t("auth.forgetPasswordEmail")
              )
            ),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isCheckedEmail,
                  expression: "isCheckedEmail",
                },
              ],
              staticClass: "form-tip",
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/images/login/alarm-clock.svg"),
                  alt: "alarm clock",
                },
              }),
              _c("span", [
                _vm._v(
                  "\n        The password must be at least 8 characters and include a number, a lowercase letter, an uppercase letter, and at least one of the supported symbols !@#$%^&*-\n      "
                ),
              ]),
            ]
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isCheckedEmail,
                  expression: "!isCheckedEmail",
                },
              ],
              ref: "form",
              staticClass: "form-container",
              attrs: { onclick: "return false" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c("div", { staticClass: "va-row" }, [
                _c("div", { staticClass: "flex md12 w-100" }, [
                  _c("div", { staticClass: "label-title" }, [
                    _c("span", { staticClass: "label-title-text" }, [
                      _vm._v(_vm._s(_vm.$t("auth.businessEmail"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      class: {
                        "has-error": _vm.errors.has("Business Email"),
                        valid: _vm.isFormFieldValid("Business Email"),
                      },
                    },
                    [
                      _c("el-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'",
                          },
                        ],
                        staticClass: "login-form-input",
                        class: {
                          "input-error": _vm.errors.first("Business Email"),
                        },
                        attrs: {
                          name: "Business Email",
                          required: "",
                          "data-vv-validate-on": "change",
                          autocomplete: "off",
                        },
                        model: {
                          value: _vm.confirmForm.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.confirmForm, "email", $$v)
                          },
                          expression: "confirmForm.email",
                        },
                      }),
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("Business Email"),
                              expression: "errors.has('Business Email')",
                            },
                          ],
                          staticClass: "help text-danger",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _vm.errors.first("Business Email")
                                ? _c("img", {
                                    staticStyle: { "margin-right": "6px" },
                                    attrs: {
                                      src: require("@/assets/images/login/attention.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.errors.first("Business Email"))
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "back-to-login w-100" }, [
                  _c("p", { staticClass: "back-login" }, [
                    _c("span", { on: { click: _vm.backToLogin } }, [
                      _vm._v(_vm._s(_vm.$t("backToLoginPage"))),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "flex md12 w-100 form-submit" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: !(
                            _vm.confirmForm.email &&
                            _vm.errors.items.length === 0
                          ),
                        },
                        on: { click: _vm.checkOutEmail },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("auth.confirm")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isCheckedEmail,
                  expression: "isCheckedEmail",
                },
              ],
              ref: "form",
              staticClass: "form-container",
              attrs: { onclick: "return false" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c("div", { staticClass: "va-row" }, [
                _c("div", { staticClass: "flex md12 w-100" }, [
                  _c("div", { staticClass: "label-title" }, [
                    _c("span", { staticClass: "label-title-text" }, [
                      _vm._v(_vm._s(_vm.$t("auth.password"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "password-container",
                      class: {
                        "has-error": _vm.errors.has("Password"),
                        valid: _vm.isFormFieldValid("Password"),
                      },
                    },
                    [
                      _c("el-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|verifyPassword|validPassword",
                            expression:
                              "'required|verifyPassword|validPassword'",
                          },
                        ],
                        staticClass: "login-form-password",
                        class: { "input-error": _vm.errors.first("Password") },
                        attrs: {
                          name: "Password",
                          autocomplete: "new-password",
                          required: "",
                          type: _vm.isOpen ? "text" : "password",
                          onkeyup: "value=value.replace(/\\s/g,'')",
                          onkeydown: "value=value.replace(/\\s/g,'')",
                        },
                        model: {
                          value: _vm.forgetFrom.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.forgetFrom, "password", $$v)
                          },
                          expression: "forgetFrom.password",
                        },
                      }),
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("Password"),
                              expression: "errors.has('Password')",
                            },
                          ],
                          staticClass: "help text-danger",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _vm.errors.first("Password")
                                ? _c("img", {
                                    staticStyle: { "margin-right": "6px" },
                                    attrs: {
                                      src: require("@/assets/images/login/attention.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _c("span", [
                                _vm._v(_vm._s(_vm.errors.first("Password"))),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "eye-password" }, [
                        !_vm.isOpen
                          ? _c("img", {
                              attrs: { src: _vm.closeEye, alt: "" },
                              on: {
                                click: () => {
                                  _vm.isOpen = true
                                },
                              },
                            })
                          : _vm._e(),
                        _vm.isOpen
                          ? _c("img", {
                              attrs: { src: _vm.openEye, alt: "" },
                              on: {
                                click: () => {
                                  _vm.isOpen = false
                                },
                              },
                            })
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "flex md12 w-100" }, [
                  _c("div", { staticClass: "label-title" }, [
                    _c("span", { staticClass: "label-title-text" }, [
                      _vm._v(_vm._s(_vm.$t("auth.confirmPassword"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "password-container",
                      class: {
                        "has-error": _vm.errors.has("Confirm Password"),
                        valid: _vm.isFormFieldValid("Confirm Password"),
                      },
                    },
                    [
                      _c("el-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value:
                              "required|verifyConfirmPassword|validPassword",
                            expression:
                              "'required|verifyConfirmPassword|validPassword'",
                          },
                        ],
                        staticClass: "login-form-password",
                        class: {
                          "input-error": _vm.errors.first("Confirm Password"),
                        },
                        attrs: {
                          name: "Confirm Password",
                          autocomplete: "new-password",
                          required: "",
                          type: _vm.isConfirmOpen ? "text" : "password",
                          onkeyup: "value=value.replace(/\\s/g,'')",
                          onkeydown: "value=value.replace(/\\s/g,'')",
                        },
                        model: {
                          value: _vm.forgetFrom.confirmPassword,
                          callback: function ($$v) {
                            _vm.$set(_vm.forgetFrom, "confirmPassword", $$v)
                          },
                          expression: "forgetFrom.confirmPassword",
                        },
                      }),
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("Confirm Password"),
                              expression: "errors.has('Confirm Password')",
                            },
                          ],
                          staticClass: "help text-danger",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _vm.errors.first("Confirm Password")
                                ? _c("img", {
                                    staticStyle: { "margin-right": "6px" },
                                    attrs: {
                                      src: require("@/assets/images/login/attention.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.errors.first("Confirm Password"))
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "eye-password" }, [
                        !_vm.isConfirmOpen
                          ? _c("img", {
                              attrs: { src: _vm.closeEye, alt: "" },
                              on: {
                                click: () => {
                                  _vm.isConfirmOpen = true
                                },
                              },
                            })
                          : _vm._e(),
                        _vm.isConfirmOpen
                          ? _c("img", {
                              attrs: { src: _vm.openEye, alt: "" },
                              on: {
                                click: () => {
                                  _vm.isConfirmOpen = false
                                },
                              },
                            })
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "flex md12 w-100" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "label-title d-flex align--end justify--space-between",
                    },
                    [
                      _c("span", { staticClass: "label-title-text" }, [
                        _vm._v(_vm._s(_vm.$t("auth.verficationCode"))),
                      ]),
                      _c("span", { staticClass: "valid-time" }, [
                        _vm._v(
                          "Valid for " + _vm._s(_vm.remainingTime) + " minutes"
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      class: {
                        "has-error": _vm.errors.has("VerficationCode"),
                        valid: _vm.isFormFieldValid("VerficationCode"),
                      },
                    },
                    [
                      _c("el-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "login-form-input",
                        class: {
                          "input-error": _vm.errors.first("VerficationCode"),
                        },
                        attrs: {
                          name: "VerficationCode",
                          autocomplete: "off",
                          required: "",
                        },
                        model: {
                          value: _vm.forgetFrom.verficationCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.forgetFrom, "verficationCode", $$v)
                          },
                          expression: "forgetFrom.verficationCode",
                        },
                      }),
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("VerficationCode"),
                              expression: "errors.has('VerficationCode')",
                            },
                          ],
                          staticClass: "help text-danger",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _vm.errors.first("VerficationCode")
                                ? _c("img", {
                                    staticStyle: { "margin-right": "6px" },
                                    attrs: {
                                      src: require("@/assets/images/login/attention.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.errors.first("VerficationCode"))
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "back-to-login w-100" }, [
                  _c("p", { staticClass: "back-login" }, [
                    _c("span", { on: { click: _vm.backToLogin } }, [
                      _vm._v(_vm._s(_vm.$t("backToLoginPage"))),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "flex md12 w-100 form-submit" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: !(
                            _vm.forgetFrom.password &&
                            _vm.forgetFrom.confirmPassword &&
                            _vm.forgetFrom.verficationCode &&
                            _vm.errors.items.length === 0
                          ),
                        },
                        on: { click: _vm.resetPassword },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("auth.confirm")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }